import {booleanFormatter, shortDatePlusTimeFormatter} from "../../gridFormatters";

export const adminColumnDefs = [
    {
        "field": "timestamp",
        "headerName": "Date",
        "width": 75,
        "cellRenderer": shortDatePlusTimeFormatter
    },
    {
        "field": "status",
        "headerName": "Succeeded",
        "width": 50,
        "cellRenderer": booleanFormatter
    },
    {
        "field": "message",
        "headerName": "Log"
    }
];

export const adminAlertsDefs = [
    {
        "field": "timestamp",
        "headerName": "Date",
        "cellRenderer": shortDatePlusTimeFormatter
    },
    {
        "field": "acknowledged",
        "headerName": "Acknowledged",
        "cellRenderer": params => {
            if (params.value === 'false') {
                return 'Unacknowledged';
            } else if (params.value === 'true') {
                return 'Acknowledged';
            } else {
                return 'Error';
            }
        }
    },
    {
        "field": "user",
        "headerName": "User"
    },
    {
        "field": "context",
        "headerName": "Context"
    },
    {
        "field": "device_name",
        "headerName": "Device Name"
    },
    {
        "field": "alert",
        "headerName": "Alert"
    },
    {
        "field": "description",
        "headerName": "Description"
    },
];